var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.963064 0.587087C0.630231 0.919921 0.599973 1.44075 0.872291 1.80776L0.963064 1.91291L9.04973 10L0.963066 18.0871C0.630232 18.4199 0.599975 18.9408 0.872293 19.3078L0.963066 19.4129C1.2959 19.7457 1.81673 19.776 2.18374 19.5037L2.28889 19.4129L11.0389 10.6629C11.3717 10.3301 11.402 9.80925 11.1297 9.44223L11.0389 9.33709L2.28889 0.587087C1.92277 0.220971 1.32918 0.220971 0.963064 0.587087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRightIcon);
export default __webpack_public_path__ + "static/media/carouselRightIcon.6d33a1b583d6c5ecfd671920cd1e0da9.svg";
export { ForwardRef as ReactComponent };